// Pendiente de revisar
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";

export class ArtifactExperimentDto extends ItiBaseDto {
	public datasetId: string;
	public datasetName: string;
	public artifactId: string;
	public artifactName: string;
	public fileType: string;
	public visibility: string;

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
	}
}
